import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

// Import pages
import Home from './pages/Home.jsx';
import Analyze from './pages/Analyze.jsx';
import HowItWorks from './pages/HowItWorks.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Plans from './pages/Plans.jsx';
import SignIn from './pages/SignIn.jsx';
import About from './pages/About.jsx';
import Contact from './pages/Contact.jsx';
import TermsOfService from './pages/TermsOfService.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import CookiePolicy from './pages/CookiePolicy.jsx';
import Deploy from './pages/Deploy.jsx';
import VibeCoding from './pages/VibeCoding.jsx';

// 🔒 Authentication guard for protected routes
import ProtectedRoute from './components/ProtectedRoute.jsx';

// Define routes
export const router = createBrowserRouter([
    {
        path: '/',
        element: <Home />,
    },
    {
        path: '/how-it-works',
        element: <HowItWorks />,
    },
    {
        path: '/plans',
        element: <Plans />,
    },
    {
        path: '/signin',
        element: <SignIn />,
    },
    {
        // 🔒 PROTECTED: Requires authentication
        path: '/analyze',
        element: <ProtectedRoute><Analyze /></ProtectedRoute>,
    },
    {
        // 🔒 PROTECTED: Legacy route - requires authentication
        path: '/analyze.html',
        element: <ProtectedRoute><Analyze /></ProtectedRoute>,
    },
    {
        // 🔒 PROTECTED: Requires authentication
        path: '/dashboard',
        element: <ProtectedRoute><Dashboard /></ProtectedRoute>,
    },
    {
        path: '/about',
        element: <About />,
    },
    {
        path: '/contact',
        element: <Contact />,
    },
    {
        path: '/terms',
        element: <TermsOfService />,
    },
    {
        path: '/privacy',
        element: <PrivacyPolicy />,
    },
    {
        path: '/cookies',
        element: <CookiePolicy />,
    },
    {
        // 🚀 PROTECTED: Deploy page - requires authentication
        path: '/deploy/:sessionId',
        element: <ProtectedRoute><Deploy /></ProtectedRoute>,
    },
    {
        // 🎨 PROTECTED: Vibe Coding page - requires authentication
        path: '/vibe/:sessionId',
        element: <ProtectedRoute><VibeCoding /></ProtectedRoute>,
    },
    // Fallback route
    {
        path: '*',
        element: <Home />,
    }
]);

// Router Provider component
export function AppRouter() {
    return <RouterProvider router={router} />;
}

export default AppRouter; 